import { useContext } from 'react';

import { Loader } from '@calm-web/design-system';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import { OfferBannerContext } from '@/components/app/layout/OfferBannerProvider';

import BackButton from './Components/BackButton';
import LazyBackgrounds from './Components/LazyBackground';
import { PreSignupFlowContext } from './PreSignupProvider';
import ScreenMap from './PreSignupScreens';
import {
	Column,
	Container,
	GridlessScreen,
	PreSignupFlowBackgroundWrapper,
	PreSignupFlowGridWrapper,
	PreSignupFlowHeader,
	ProgressBar,
	ProgressBarContainer,
} from './styles';

const PreSignupFlowContainer = () => {
	const { ActiveScreen, onExit, skipToEnd } = useContext(PreSignupFlowContext);
	const { isBannerVisible } = useContext(OfferBannerContext);

	if (!ActiveScreen) {
		return <Loader />;
	}

	const {
		componentName,
		showNav,
		isFullScreen = false,
		bgColor,
		canExit,
		questionNumber,
		totalQuestions,
		hasPadding = true,
	} = ActiveScreen;

	const showProgressBar = questionNumber && totalQuestions;
	const startingPoint = questionNumber && totalQuestions ? ((questionNumber - 1) / totalQuestions) * 100 : 0;
	const percentComplete = questionNumber && totalQuestions ? (questionNumber / totalQuestions) * 100 : 0;

	return (
		<>
			<LazyBackgrounds />
			<PreSignupFlowBackgroundWrapper>
				{showNav && (
					<PreSignupFlowHeader
						freeCTAColorBG="accessibleBrandGradient"
						freeCTAColorText="white"
						onFreeCtaClick={skipToEnd}
						isForHandoff={isFullScreen}
						isStatic={true}
						hideLogo={false}
						hideMenu={false}
						hideForBusinessCta
						hideProfile
						onExit={canExit ? onExit : undefined}
						alignLeft={false}
						hideAuthCTA={true}
						hideHambugerNav
						hideFreeTrialCta={componentName !== 'FocusedLandingPage'}
						logoColor="gradient"
					/>
				)}
				{showProgressBar && (
					<ProgressBarContainer>
						<ProgressBar startingPoint={startingPoint} percentComplete={percentComplete} />
					</ProgressBarContainer>
				)}
				{isFullScreen ? (
					<GridlessScreen
						headerPresent={showNav}
						scrollable={componentName === 'FocusedLandingPage'}
						isBannerVisible={isBannerVisible}
					>
						{ScreenMap[componentName]}
					</GridlessScreen>
				) : (
					<Container bgColor={bgColor}>
						<PreSignupFlowGridWrapper el="main" columns={isFullScreen ? 0 : 4} id={MAIN_CONTENT_ID}>
							<BackButton />
							<Column hasPadding={hasPadding}>{ScreenMap[componentName]}</Column>
						</PreSignupFlowGridWrapper>
					</Container>
				)}
			</PreSignupFlowBackgroundWrapper>
		</>
	);
};

export default PreSignupFlowContainer;
